module.exports = __webpack_public_path__ + "static/media/crayon-logo.284d91b7.png";